document.addEventListener('DOMContentLoaded', function () {
  // ===== Results Tabs + Video Controls =====
  const seeResultsWrapper = document.querySelector('.results-tabs-wrapper');

  if (seeResultsWrapper) {
    const seeResultsContent = seeResultsWrapper.querySelectorAll('.results-video-container');
    const seeResultsNav = seeResultsWrapper.querySelectorAll('.results-nav-item');
    // Collect any elements with class .results-video (expecting <video> tags)
    const baVideos = seeResultsWrapper.querySelectorAll('.results-video');

    const switchActiveVideo = () => {
      baVideos.forEach((video) => video.classList.remove('active'));
    };

    const pauseAllVideos = () => {
      baVideos.forEach((video) => {
        try { video.pause(); } catch (e) {}
      });
    };

    const handleVideoPlay = (event) => {
      // When any video starts, mark only it as active
      switchActiveVideo();
      event.target.classList.add('active');
    };

    const handleVideoClick = (event) => {
      const video = event.currentTarget;
      if (video.paused) {
        // Start this video, pause others
        pauseAllVideos();
        video.play();
      } else {
        // Toggle pause on the current video
        video.pause();
      }
    };

    const handleVideoEnded = (event) => {
      const video = event.currentTarget;
      switchActiveVideo();
      video.classList.remove('active');
      // Play next sibling <video> if present
      let next = video.nextElementSibling;
      while (next && next.tagName !== 'VIDEO') {
        next = next.nextElementSibling;
      }
      if (next && next.tagName === 'VIDEO') {
        next.classList.add('active');
        next.play();
      }
    };

    // Attach listeners once
    baVideos.forEach((video) => {
      video.addEventListener('play', handleVideoPlay);
      video.addEventListener('click', handleVideoClick);
      video.addEventListener('ended', handleVideoEnded);
    });

    const showResults = (results) => {
      seeResultsContent.forEach((content) => {
        const resultsData = content.getAttribute('data-tab');
        if (resultsData === results) {
          content.classList.add('active');
          // Auto-play first video in the newly active tab
          const firstVideo = content.querySelector('video');
          if (firstVideo) {
            pauseAllVideos();
            switchActiveVideo();
            firstVideo.classList.add('active');
            firstVideo.play();
          }
        } else {
          content.classList.remove('active');
        }
      });
    };

    // Nav click handling
    seeResultsNav.forEach((navItem) => {
      navItem.addEventListener('click', () => {
        const tab = navItem.getAttribute('data-tab');
        seeResultsNav.forEach((n) => n.classList.remove('active'));
        navItem.classList.add('active');
        pauseAllVideos();
        showResults(tab);
      });
    });
  }

  // ===== Side Cart Upsell (delegated) =====
  const sideCart = document.querySelector('#site-cart-sidebar');
  if (sideCart) {
    sideCart.addEventListener('click', (e) => {
      const btn = e.target.closest('.cart-upsell-btn');
      if (btn && btn.dataset.variantId) {
        addCartRecToCart(btn.dataset.variantId, 1);
      }
    });
  }
});

async function addCartRecToCart(variantId, quantity = 1) {
  const data = { id: variantId, quantity };
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    await response.json();
    // Safely call if defined
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    }
  } catch (error) {
    console.error(error);
  }
}
